import { useState } from "react";
import BaseInput from "../BaseInput";

const formatDateDisplay = (value) => {
    if (!value) return value;

    // First, remove all non-digits and limit to 8 digits
    const digits = value.replace(/\D/g, "").slice(0, 8);

    if (digits.length <= 2) {
        return digits;
    } else if (digits.length <= 4) {
        return `${digits.slice(0, 2)}/${digits.slice(2)}`;
    } else {
        return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
    }
};

const isValidDate = (day, month, year) => {
    // Convert to numbers
    const d = parseInt(day, 10);
    const m = parseInt(month, 10);
    const y = parseInt(year, 10);

    // Basic validation
    if (isNaN(d) || isNaN(m) || isNaN(y)) return false;
    if (d < 1 || d > 31) return false;
    if (m < 1 || m > 12) return false;
    if (y < 1 || y > 9999) return false;

    // Check days in month
    const daysInMonth = new Date(y, m, 0).getDate();
    return d <= daysInMonth;
};

const formatDateExternal = (value) => {
    if (!value) return value;
    const digits = value.replace(/\D/g, "");

    if (digits.length < 8) return value;

    const day = digits.slice(0, 2);
    const month = digits.slice(2, 4);
    const year = digits.slice(4, 8);

    // Validate date before returning
    if (!isValidDate(day, month, year)) return value;

    return `${year}-${month}-${day}`;
};

const convertExternalToDisplay = (externalDate) => {
    if (!externalDate) return "";
    const [year, month, day] = externalDate.split("-");
    if (!year || !month || !day) return "";

    // Validate date before converting
    if (!isValidDate(day, month, year)) return "";

    return `${day}/${month}/${year}`;
};

const DateInput = ({ value, onInput, label = 'Data', placeholder = 'dd/mm/aaaa', variant = 'light', ...props }) => {
    const [localValue, setLocalValue] = useState(convertExternalToDisplay(value) || "");

    const handleChange = (newValue) => {
        const digits = newValue.replace(/\D/g, "").slice(0, 8);
        const displayValue = formatDateDisplay(digits);
        setLocalValue(displayValue);

        onInput(formatDateExternal(digits));
    };

    return (
        <BaseInput
            {...props}
            value={localValue}
            onInput={handleChange}
            label={label}
            placeholder={placeholder}
            variant={variant}
            maxLength={10}
        />
    );
};

export default DateInput;
